import {img} from '../utils/img';
import { defaultConfiguration } from '../utils/vars';
import barnoImg from './../assets/img/Barno1.jpg';

import React from 'react';

export default class FirstStage extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <section className='first-stage'>
                <h1 className='first-stage__title'>Выберите коллекцию, <br/>которую вы хотели бы редактировать</h1>
                <p className='first-stage__paragraph'>Это вдохновляющие изображения. Товары могут быть изменены в дальнейших шагах.</p>
                <div className='first-stage__grid'>
                    {defaultConfiguration.map((config,i) => {
                        let cleanConfig = {};
                        for(let key in config) {
                            const secondLevelObj = config[key];
                            if(key !== 'img') {
                                cleanConfig[key] = {};
                                for(let keySecond in secondLevelObj) {
                                    if(secondLevelObj[keySecond] === '') {
                                        cleanConfig[key][keySecond] = false;
                                    }
                                    else {
                                        cleanConfig[key][keySecond] = secondLevelObj[keySecond];
                                    }
                                }
                            }
                            else {
                                cleanConfig[key] = config[key];
                            }
                        }
                        for(let key in cleanConfig) {
                            if(Object.keys(cleanConfig[key]).length === 0){
                                cleanConfig[key] = false;
                            }
                        }
                        return(
                            <button key={i} className='first-stage__card' 
                                onClick={() => {
                                    this.props.updatePreloader(true)
                                    this.props.updateConfig(cleanConfig).then(res => {
                                        this.props.changeCurrentStage(2);
                                        this.props.updatePreloader(false);
                                    })
                                }
                            }>
                                <img src={config.img}/>
                            </button>
                    )})}
                </div>
            </section> 
        )
    }
}